// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3qz9q","left":"StickyBox_left__HgcbD","right":"StickyBox_right__1DXxK"};